<rb-dialog (buttonClick)="onDialogButtonClick()"
           (closeClick)="onClose()"
           (maximizedChange)="onMaximizedChange($event)"
           [(maximized)]="dialogMaximized"
           [config]="dialogConfig"
           xmlns="http://www.w3.org/1999/html">
  <div class="flex gap-x-[4rem]">
    <rb-view-section class="w-[calc(100%-24rem)]">
      <ng-container *ngrxLet="viewDocumentType$ | async as viewDocumentType">
        <div *ngrxLet="viewDocumentUrl$ | async as viewDocumentUrl"
             [style.max-height]="docViewerMaxHeight"
             class="overflow-hidden rounded-[0.5rem] h-[100vh] w-full">
          <rb-image-viewer *ngIf="viewDocumentType === 'image'"
                           alt="document"
                           class="block h-full w-full"
                           src="{{ viewDocumentUrl }}"></rb-image-viewer>
          <rb-pdf-viewer *ngIf="viewDocumentType === 'pdf'"
                         class="block h-full w-full"
                         src="{{ viewDocumentUrl }}"></rb-pdf-viewer>
          <div *ngIf="!viewDocumentType"
               class="flex flex-col justify-center items-center gap-y-[1rem] h-full">
            <mat-icon [class.icon-brand]="needsBrandColor(request.document.extension)"
                      [svgIcon]="fileIcon(request.document.extension)"
                      class="icon-40"></mat-icon>
            <span>{{ request.document.name }}.{{ request.document.extension }}</span>
          </div>
        </div>
      </ng-container>
    </rb-view-section>
    <div class="w-[20rem] flex flex-col gap-y-[1rem] py-[0.5rem]">
      <button (click)="downloadDocument()"
              [disabled]="anyActionLoading$ | async"
              class="justify-start"
              mat-button>
        <mat-icon *ngIf="(documentDownloadId$ | async) !== request.document.id"
                  class="icon-brand"
                  svgIcon="download"></mat-icon>
        <mat-spinner *ngIf="(documentDownloadId$ | async) === request.document.id"
                     class="spinner-brand"
                     diameter="15"></mat-spinner>
        <span>{{ 'APP.DOCUMENTS.DOWNLOAD' | translate }}</span>
      </button>
      <button (click)="renameDocument()"
              [disabled]="anyActionLoading$ | async"
              class="justify-start"
              mat-button>
        <mat-icon class="icon-brand" svgIcon="edit"></mat-icon>
        <span>{{ 'APP.DOCUMENTS.RENAME' | translate }}</span>
      </button>
      <ng-container *ngIf="canPayDocument$ | async">
        <button (click)="createPayment()"
                *ngIf="!request.document.payment || request.document.payment.status !== PaymentStatus.NOT_SUBMITTED"
                [disabled]="anyActionLoading$ | async"
                class="justify-start"
                mat-button>
          <mat-icon *ngIf="(fetchingDocumentPaymentDataId$ | async) !== request.document.id"
                    class="icon-brand"
                    svgIcon="payments"></mat-icon>
          <mat-spinner *ngIf="(fetchingDocumentPaymentDataId$ | async) === request.document.id"
                       class="spinner-brand"
                       diameter="15"></mat-spinner>
          <div class="inline-block">
            <div class="flex items-baseline gap-x-[1rem]">
              <span>{{
                  (request.document.payment ? 'APP.DOCUMENTS.REPEAT_PAYMENT' :
                    'APP.DOCUMENTS.CREATE_PAYMENT') | translate
                }}</span>
              <span class="font-bold text-warning text-xs">BETA</span>
            </div>
          </div>
        </button>
        <button (click)="editPayment()"
                *ngIf="request.document.payment && request.document.payment.status === PaymentStatus.NOT_SUBMITTED"
                [disabled]="anyActionLoading$ | async"
                class="justify-start"
                mat-button>
          <mat-icon *ngIf="(fetchingDocumentPaymentDataId$ | async) !== request.document.id"
                    class="icon-brand"
                    svgIcon="payments"></mat-icon>
          <mat-spinner *ngIf="(fetchingDocumentPaymentDataId$ | async) === request.document.id"
                       class="spinner-brand"
                       diameter="15"></mat-spinner>
          <div class="inline-block">
            <div class="flex items-baseline gap-x-[1rem]">
              <span>{{ 'APP.DOCUMENTS.EDIT_PAYMENT' | translate }}</span>
              <span class="font-bold text-warning text-xs">BETA</span>
            </div>
          </div>
        </button>
      </ng-container>
      <button (click)="assignDocument()"
              *ngIf="request.document.ownDocument && !request.document.payment && !request.document.shared && !isRbDocumentType(request.document.type)"
              [disabled]="anyActionLoading$ | async"
              class="justify-start"
              mat-button>
        <mat-icon *ngIf="!((fetchingDocumentAssignmentDataIds$ | async) ?? []).includes(request.document.id)"
                  class="icon-brand"
                  svgIcon="clients"></mat-icon>
        <mat-spinner *ngIf="((fetchingDocumentAssignmentDataIds$ | async) ?? []).includes(request.document.id)"
                     class="spinner-brand"
                     diameter="15"></mat-spinner>
        <span>{{ 'APP.DOCUMENTS.ASSIGN' | translate }}</span>
      </button>
      <button (click)="toggleDocumentHidden()"
              *ngIf="request.document.processed"
              [disabled]="anyActionLoading$ | async"
              class="justify-start"
              mat-button>
        <mat-icon *ngIf="(toggleDocumentHiddenIsLoadingId$ | async) !== request.document.id"
                  [svgIcon]="request.document.hidden ? 'visible' : 'hidden'"
                  class="icon-brand"></mat-icon>
        <mat-spinner *ngIf="(toggleDocumentHiddenIsLoadingId$ | async) === request.document.id"
                     class="spinner-brand"
                     diameter="15"></mat-spinner>
        <span>{{ (request.document.hidden ? 'APP.DOCUMENTS.MAKE_VISIBLE' : 'APP.DOCUMENTS.HIDE') | translate }}</span>
      </button>
      <button (click)="toggleDocumentShared()"
              *ngIf="request.document.client && request.document.ownDocument"
              [disabled]="anyActionLoading$ | async"
              class="justify-start"
              mat-button>
        <mat-icon *ngIf="(toggleDocumentSharedIsLoadingId$ | async) !== request.document.id"
                  [svgIcon]="request.document.shared ? 'stop' : 'share'"
                  class="icon-brand"></mat-icon>
        <mat-spinner *ngIf="(toggleDocumentSharedIsLoadingId$ | async) === request.document.id"
                     class="spinner-brand"
                     diameter="15"></mat-spinner>
        <span>{{ (request.document.shared ? 'APP.DOCUMENTS.STOP_SHARING' : 'APP.DOCUMENTS.SHARE') | translate }}</span>
      </button>
      <button (click)="deleteDocument()"
              *ngIf="request.document.ownDocument"
              [disabled]="anyActionLoading$ | async"
              class="justify-start"
              mat-button>
        <mat-icon class="icon-brand" svgIcon="delete"></mat-icon>
        <span>{{ 'APP.DOCUMENTS.DELETE' | translate }}</span>
      </button>
    </div>
  </div>
</rb-dialog>
